export const removeMask = (value: any): string | null => {
  if (typeof value === 'string') {
    return value.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '').replaceAll('+', '').replaceAll(',', '')
  } else {
    return value
  }
}

export default removeMask
